/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import {RequiredPayPlans} from './OrganisationType';
import {channelDefState} from './ChannelDefType';
import * as Permission from "../util/Permission";
import config from '../../common/config';

export const supportedHandlers = {
    "notes": {
        name: "Notes"
    },
    "todos": {
        name: "Todos"
    },
    "iframe": {
        name: "IFrame"
    },
    "add-relation": {
        name: "Add Relation"
    },
    "js-action" : {
        name: "JS Action"
    },
};

export default declareEntity({
    entity: "addonDefs",
    graphQL: "AddonDef",
    dynamoPrefix: 'def',
    storageType: 'schema',
    name: "Addon Definition",
    defaultTitle: (data) => {
        return data['name'];
    },
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    isPublic: true,
    onModify: ['channelDef'],
    fields: (types) => { return {
        id: {
            name: "Addon Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            isPublic: true,
        },
        name: {
            name: "Name",
            type: "string",
            defaultValue: "",
            translatable: true,
            filterable: true,
            required: true,
            isPublic: true,
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: "",
            isPublic: true,
        },
        handler: {
            name: "Handler",
            type: "enum",
            defaultValue: "notes",
            values: supportedHandlers,
            isPublic: true,
        },
        options: {
            name: "Options",
            type: "object",
            defaultValue: {},
        },
        channelDef: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            defaultValue: (groupDef) => {
                return groupDef['channelDef_id'];
            },
            type: "relation",
            isPublic: true,
        },
        allowConnectedChannelSelection: {
            name: "Allow connected application selection",
            type: "boolean",
            isPublic: true,
            defaultValue: false,
        },
        requiredPayPlan: {
            name: "Required Plan",
            type: "enum",
            isPublic: true,
            values: RequiredPayPlans,
        },
        popularity: {
            name: "Popularity",
            type: "int",
            isPublic: true,
            defaultValue: 1,
            import: false,
            export: false,
        },
        state: {
            name: "State",
            type: "enum",
            filterable: true,
            isPublic: true,
            defaultValue: "draft",
            values: channelDefState
        },
        visibility: {
            name: "Visibility",
            type: "enum",
            filterable: true,
            isPublic: true,
            defaultValue: "private",
            values: {
                "private": {
                    name: "Private",
                },
                "unlisted": {
                    name: "Unlisted",
                },
                "public": {
                    name: "Public",
                },
            }
        },
        deprecated: {
            name: "Is Deprecated?",
            type: "boolean",
            defaultValue: false,
            filterable: true,
            isPublic: true,
        },
        version: {
            name: "Version",
            type: "int",
            defaultValue: 1
        },
        developerGroup: {
            name: "Developer",
            type: "relation",
            to: () => types['developerGroups'],
            defaultValue: config.DEVELOPER_DATIVERY,
            userEditable: true,
            required: true,
            isPublic: true,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
